import { defineMessages } from 'react-intl';

const translations = {
  actions: {
    finish: {
      id: 'actions.finish',
      defaultMessage: 'Finish',
      description: 'Label of the finish action on the put away page',
    },
  },
};

export default defineMessages(translations);
